<template>
  <b-toast
    class="box-shadow"
    header-class="fs-16 font-weight-medium notification-worker"
    body-class="fa-14 font-weight-normal"
    v-model="isShow"
    v-if="notification"
    auto-hide-delay="2000"
    solid
  >
    <template v-slot:toast-title>
      <span @click="showInfo">{{ notification.title || 'No title' }}</span>
    </template>
    <div class="text-truncate" @click="showInfo">
      <span>{{ notification.body }}</span>
    </div>
  </b-toast>
</template>

<script>
export default {
  name: 'notificationWorker',
  data: function() {
    return {
      notification: {},
      isShow: false,
      jobId: '',
      t: 0
    }
  },
  methods: {
    open(data) {
      if (data && data !== -1) {
        this.notification = data.notification
        this.jobId = data.data.id
        this.isShow = true
        this.t = +data.data.t
      }
    },
    showInfo() {
      this.isShow = false
      const link = this.buildLink()
      this.$router.push(link)
      return true
    },
    buildLink: function() {
      let link = ''
      switch (this.t) {
        case 1:
          return `/job/${this.jobId}`
        case 2:
          link = `/my-hires?status=2&category=1&tab=1`
          if (this.jobId) {
            link = `/my-hires?status=2&category=1&tab=1&id=${this.jobId}`
          }
          return link
        case 3:
          link = `/my-hires?status=2&category=1&tab=2`
          if (this.jobId) {
            link = `/my-hires?status=2&category=1&tab=2&id=${this.jobId}`
          }
          return link
        case 6:
          link = `/my-jobs?status=2&category=1&tab=2`
          if (this.jobId) {
            link = `/my-jobs?status=2&category=1&tab=2&id=${this.jobId}`
          }
          return link
        case 7:
          link = `/my-jobs?status=1&category=1&tab=1`
          if (this.jobId) {
            link = `/my-jobs?status=1&category=1&tab=1&id=${this.jobId}`
          }
          return link
        default:
          return link
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/notifications/notification-worker.vue